import { Eyebrow } from './Eyebrow.jsx';
import { Button } from './Button.jsx';
import { Reveal } from './motion.jsx';
import styles from './CtaBanner.module.css';

/**
 * The closing call to action. It appears at the foot of five pages, each
 * previously with its own hand-written copy of the same markup.
 */
export function CtaBanner({
  eyebrow = 'Start Your Project',
  lines,
  action = 'Get in Touch',
  to = '/contact',
  onDark = false,
}) {
  return (
    <Reveal className={styles.banner}>
      <div>
        <Eyebrow onDark={onDark} animated={false}>{eyebrow}</Eyebrow>
        <h2 className="h2 mt-2">
          {lines.map((line, i) => (
            <span key={line}>
              {i > 0 ? <br /> : null}
              {line}
            </span>
          ))}
        </h2>
      </div>
      <Button to={to} variant={onDark ? 'onDark' : 'primary'}>
        {action}
      </Button>
    </Reveal>
  );
}
